(function () {
  var SPECS = [
    { sel: '.wp-goals', cls: 'wr-goals' },
    { sel: '.wp-flash__g', cls: 'wr-flash' },
    { sel: '.wp-rail', cls: 'wr--keep' },
    { sel: '.wp-kn--rail', cls: 'wr-kn' },
    { sel: '.wp-goalres .wp-grid', cls: 'wr-cards' },
    { sel: '.wp-sets', cls: 'wr-cards' },
    { sel: '.wp-bestgrid', cls: 'wr-cards' }
  ];
  var RAILS = [];

  function chev(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wr__nav wr__nav--' + (dir < 0 ? 'p' : 'n');
    b.setAttribute('aria-label', dir < 0 ? 'Scroll left' : 'Scroll right');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' +
      (dir < 0 ? 'M15 5 8 12l7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
    return b;
  }

  function update(r) {
    var t = r.t, max = t.scrollWidth - t.clientWidth;
    r.w.classList.toggle('wr--l', t.scrollLeft > 4);
    r.w.classList.toggle('wr--r', max > 4 && t.scrollLeft < max - 4);
  }

  function refresh() { RAILS.forEach(update); }

  function build(t, cls) {
    if (t.getAttribute('data-wr') || !t.children.length) return;
    t.setAttribute('data-wr', '1');
    var w = document.createElement('div');
    w.className = 'wr ' + cls;
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
    t.classList.add('wr__track');
    var p = chev(-1), n = chev(1);
    w.appendChild(p);
    w.appendChild(n);
    var r = { w: w, t: t };
    RAILS.push(r);
    var anim = null;
    function go(d) {
      var dist = d * Math.max(180, t.clientWidth * 0.85);
      var from = t.scrollLeft;
      var max = t.scrollWidth - t.clientWidth;
      var to = Math.max(0, Math.min(max, from + dist));
      var t0 = 0;
      if (anim) cancelAnimationFrame(anim);
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 280);
        var e = 1 - Math.pow(1 - p, 3);
        t.scrollLeft = from + (to - from) * e;
        if (p < 1) anim = requestAnimationFrame(step);
        else { anim = null; update(r); }
      }
      anim = requestAnimationFrame(step);
      setTimeout(function () {
        if (anim) { cancelAnimationFrame(anim); anim = null; }
        if (Math.abs(t.scrollLeft - to) > 1) t.scrollLeft = to;
        update(r);
      }, 380);
    }
    p.addEventListener('click', function () { go(-1); });
    n.addEventListener('click', function () { go(1); });
    t.addEventListener('scroll', function () { update(r); }, { passive: true });
    update(r);
  }

  function scan() {
    SPECS.forEach(function (s) {
      var list = document.querySelectorAll(s.sel);
      for (var i = 0; i < list.length; i++) build(list[i], s.cls);
    });
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', function () { setTimeout(scan, 40); });
  window.addEventListener('resize', refresh);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-wp-goal],[data-adv-go],[data-adv-ex]')) {
      setTimeout(scan, 90);
      setTimeout(refresh, 400);
    }
  }, true);
})();
